import { Box, Button, Paper } from "@mui/material";
import { useTranslate } from "../../components/Translate/TranslateContext";
import { useState } from "react";
import { submitCropSuggestion } from "../../api/userRegistration";

import PersonalInfoSection from "./User/PersonalInfoSection";
import { selectStyle } from "../../styles/ComponentStyles";

export default function UserRegistration({
    form,
    setForm,
    cropTypes,
    cropVarieties,
    onSubmit,
}) {
    const { translate } = useTranslate();

    const [modalOpen, setModalOpen] = useState(false);
    const [suggestionType, setSuggestionType] = useState("crop_type");
    const [suggestionCropType, setSuggestionCropType] = useState("");
    const [suggestedValue, setSuggestedValue] = useState("");

    // Field-level validation errors
    const [errors, setErrors] = useState({});

    // Basic client-side validation
    const validate = () => {
        const newErrors = {};

        if (!form.first_name) newErrors.first_name = "error_required";
        if (!form.last_name) newErrors.last_name = "error_required";

        if (!form.email) {
            newErrors.email = "error_required";
        } else if (!/\S+@\S+\.\S+/.test(form.email)) {
            newErrors.email = "error_invalid_email";
        }

        if (!form.password) {
            newErrors.password = "error_required";
        } else if (form.password.length < 8) {
            newErrors.password = "error_password_short";
        }

        if (!form.country_code) newErrors.country = "error_required";
        if (!form.region) newErrors.region = "error_required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validate()) return;
        onSubmit(form);
    };

    const handleSuggestionSubmit = async () => {
        if (!suggestedValue) return;

        await submitCropSuggestion({
            suggestion_type: suggestionType,
            crop_type_key:
                suggestionType === "crop_variety"
                    ? suggestionCropType
                    : null,
            suggested_value: suggestedValue,
        });

        setSuggestedValue("");
        setSuggestionCropType("");
        setSuggestionType("crop_type");
        setModalOpen(false);
    };

    const fieldSx = { mt: 2 };
const isFormValid =
    form.first_name?.trim() &&
    form.last_name?.trim() &&
    /\S+@\S+\.\S+/.test(form.email || "") &&
    form.password?.length >= 8 &&
    form.country_code &&
    form.region;
      

    return (
        <Box
            sx={{
                minHeight: "500px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: 2,
                py: 2,
                backgroundColor: "var(--color-bg-primary)",
            }}
        >
            <Paper
                component="form"
                onSubmit={handleSubmit}
                elevation={0}
                sx={{
                    width: "100%",
                    maxWidth: 560,
                    p: { xs: 2, md: 3 },
                    backgroundColor: "var(--color-bg-primary)",
                    border: "1px solid var(--color-green-strong)",
                }}
            >
                <PersonalInfoSection
                    form={form}
                    setForm={setForm}
                    translate={translate}
                    fieldSx={fieldSx}
                    selectStyle={selectStyle}
                    errors={errors}
                />


                <Button
    type="submit"
    variant="contained"
    size="large"
    fullWidth
    disabled={!isFormValid}
    sx={{ mt: 4 }}
>
    {translate("continue")}
</Button>
            </Paper>

   
        </Box>
    );
}
